import { render, staticRenderFns } from "./tracking-add.vue?vue&type=template&id=a4437480&"
import script from "./tracking-add.vue?vue&type=script&lang=js&"
export * from "./tracking-add.vue?vue&type=script&lang=js&"
import style0 from "./tracking-add.vue?vue&type=style&index=0&id=a4437480&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports